export default "__VITE_ASSET__avruW37___"